import React from 'react';
import { AdmissionTrendsTracker } from '../components/trends/AdmissionTrendsTracker';

export const TrendsTrackerPage: React.FC = () => {
  return <AdmissionTrendsTracker />;
};